import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { DialogComponent } from 'src/app/components';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sales-report-export-dialog',
  host: { class: 'dialog' },
  templateUrl: './sales-report-export.dialog.html'
})
export class SalesReportExportDialog implements AfterViewInit {
  @ViewChild('dialog', { static: true, read: DialogComponent })
  private _dialog: DialogComponent;

  constructor(
    public dialogRef: MatDialogRef<SalesReportExportDialog>
  ) {}

  public ngAfterViewInit(): void {
    this._dialog.dataLoaded$.subscribe((state) => {
      if (!state) {
        return;
      }

      this._dialog.closeDialog();
    });
  }
}
